export function SponsorsSlide() {
	this.cycle = true;
	this.slides = [
		'/assets/images/sponsors/sponsor-slide-1.jpg?m=202208102233',
		'/assets/images/sponsors/sponsor-slide-2.jpg?m=202208102233'
	];
	this.currentSlide = Math.floor(Math.random() * this.slides.length);
}

SponsorsSlide.prototype.elementCreated = function(element) {
	this.element = element;
	this.image = element.querySelector('img');
};
SponsorsSlide.prototype.prepare = function() {
	var currentSlide = this.currentSlide;
	var imageSrc = this.slides[currentSlide];
	this.image.src = imageSrc;
	this.currentSlide = (currentSlide + 1) % this.slides.length;
};
